import { dew as _isValidIdentifier2Dew } from "../validators/isValidIdentifier";
import * as _helperValidatorIdentifier3 from "@babel/helper-validator-identifier";
var _helperValidatorIdentifier2 = "default" in _helperValidatorIdentifier3 ? _helperValidatorIdentifier3.default : _helperValidatorIdentifier3;
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = toIdentifier;
  var _isValidIdentifier = _isValidIdentifier2Dew();
  var _helperValidatorIdentifier = _helperValidatorIdentifier2;
  function toIdentifier(input) {
    input = input + "";
    let name = "";
    for (const c of input) {
      name += (0, _helperValidatorIdentifier.isIdentifierChar)(c.codePointAt(0)) ? c : "-";
    }
    name = name.replace(/^[-0-9]+/, "");
    name = name.replace(/[-\s]+(.)?/g, function (match, c) {
      return c ? c.toUpperCase() : "";
    });
    if (!(0, _isValidIdentifier.default)(name)) {
      name = `_${name}`;
    }
    return name || "_";
  }

  //# sourceMappingURL=toIdentifier.js.map
  return exports;
}